import React, { useEffect, useRef } from "react";
import "./WhyUs.css";

const STATS = [
  {
    value: "200+",
    title: "Candidates Placed",
    desc: "Professionals placed in roles matching their skills and ambitions, each and every year without fail.",
    icon: "🚀",
  },
  {
    value: "98%",
    title: "Client Satisfaction",
    desc: "An industry-leading satisfaction rate earned through transparent processes and genuine care for outcomes.",
    icon: "⭐",
  },
  {
    value: "50+",
    title: "Company Partners",
    desc: "A growing network of reputable employers across IT, finance, healthcare, and operations sectors.",
    icon: "🤝",
  },
  {
    value: "10+",
    title: "Years of Expertise",
    desc: "Over a decade navigating the talent market — we know exactly what hiring managers are looking for.",
    icon: "🏆",
  },
];

const WhyUs = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.08 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="whyus" id="why" ref={ref}>
      <div className="whyus__inner">
        <div className="whyus__header reveal">
          <span className="eyebrow">Why Placify</span>
          <h2 className="whyus__h2">Numbers That Speak<br />for Themselves</h2>
          <p className="whyus__sub">
            A track record built on real placements, real transformations, and real relationships.
          </p>
        </div>

        <div className="whyus__grid">
          {STATS.map((s, i) => (
            <div
              className="whyus__card glass glass-hover reveal"
              key={i}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className="whyus__icon">{s.icon}</div>
              <div className="whyus__value grad-text">{s.value}</div>
              <h4 className="whyus__title">{s.title}</h4>
              <p className="whyus__desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
